import { useMemo } from "react";
import { Box } from "@chakra-ui/layout";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";

import moment from "moment";
import { ParcelaAcordo } from "core/features/acordo/typings";
import CustomTag from "ui/components/Tags/CustomTag";

function useListagemParcelaAcordoColumns() {
  return useMemo(() => {
    return [
      {
        title: "Parcela",
        width: "50px",
        render: (original: ParcelaAcordo, _: ParcelaAcordo, index: number) => (
          <Box textAlign="center">{index + 1}ª</Box>
        ),
      },
      {
        title: "Vencimento",
        render: (original: ParcelaAcordo) => (
          <Box>{moment(original.dataVencimento).format("DD/MM/YYYY")}</Box>
        ),
      },
      {
        title: "Valor da Parcela",
        render: (original: ParcelaAcordo) => (
          <Box>R$ {original.valor ? formatCurrency(original.valor) : "--"}</Box>
        ),
      },
      {
        title: "Situação",
        width: "150px",
        render: (original: ParcelaAcordo) => {
          const isAtrasado = moment(original.dataVencimento).isBefore(
            moment().format("YYYY-MM-DD")
          );

          const isRenegociado = !!original.dataRenegociacao;

          const isDeletado = original.deletedAt;

          const isPendente =
            !original.valorPago && !isAtrasado && !isRenegociado && !isDeletado;

          const _isAtrasado =
            !original.valorPago && isAtrasado && !isRenegociado && !isDeletado;

          return (
            <Box>
              {original.valorPago ? (
                <CustomTag color="green.500"> Pago </CustomTag>
              ) : null}

              {isRenegociado ? (
                <CustomTag color="gray.500"> Renegociado </CustomTag>
              ) : null}

              {isPendente ? (
                <CustomTag color="blue.500"> Pendente </CustomTag>
              ) : null}

              {_isAtrasado ? (
                <CustomTag color="red.500"> Atrasado </CustomTag>
              ) : null}

              {isDeletado ? (
                <CustomTag color="red.500"> Cancelada </CustomTag>
              ) : null}
            </Box>
          );
        },
      },
    ];
  }, []);
}

export default useListagemParcelaAcordoColumns;
